export default "__VITE_ASSET__CVQpp710__"